import { debounce } from './utils'

// Menu Toggler

export function menuToggler() {

  document.querySelectorAll('.hamburger').forEach(
    hamburger => hamburger.addEventListener('click', () => {
      document.body.classList.toggle('mobile-menu-open');
    })
  )

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.body.classList.remove('mobile-menu-open');
    }
  });

  document.querySelectorAll('.nav-container').forEach(
    container => container.addEventListener('click', (event) => {
      if (!event.target.closest('.main-nav-wrapper')) {
        document.body.classList.remove('mobile-menu-open');
      }
    })
  )
}

// Fix 100vh Problem on Mobile browsers
export function mobileViewHeightFix () {
  const element = document.querySelector('.full-screen-height')

  if (element) {
    const viewportHeight = element.getBoundingClientRect().height
    element.style.height = viewportHeight + 'px'
  }
}

export function onLoadOrResize() {
  const winWidth = window.innerWidth
  if ( winWidth >= 1024 && document.body.classList.contains('mobile-menu-open') ) {
    document.body.classList.remove('mobile-menu-open');
  }
}

// Measure the real scrollbar width with an off-screen overflow probe, isolated
// from page layout. The old `innerWidth - documentElement.clientWidth` heuristic
// could blow up to ~600px+ in mobile view when the page overflows horizontally
// (the layout and visual viewports diverge, so the two widths no longer differ by
// just the scrollbar). The probe only ever measures the scrollbar itself, and
// returns 0 on overlay-scrollbar systems (typical on mobile). Re-run on resize so
// an orientation/zoom change can't leave a stale value.
function setScrollBarWidth() {
  if (!document.body) return;
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll';
  document.body.appendChild(probe);
  document.body.style.setProperty('--scroll-bar-width', `${probe.offsetWidth - probe.clientWidth}px`);
  probe.remove();
}

// Toggle html.is-scrolled once the page leaves the top, so the mobile header can
// shrink its logo (see 30_header.sass). State-guarded so the class only flips on
// the actual transition rather than on every scroll event.
function setupHeaderScroll() {
  const root = document.documentElement;
  // Only the front page plays the big-logo-shrinks-on-scroll act. Subpages pin
  // the compact state from the start — no listener, so the header size (and
  // everything reading --header-height-current, like the projects filter)
  // never changes mid-page there. body:not(.home) in 30_header.sass covers
  // the heights for the frame before this runs.
  if (!document.body.classList.contains('home')) {
    root.classList.add('is-scrolled');
    return;
  }

  // Fallback driver for the scroll-linked logo shrink (see 30_header.sass).
  // Browsers with scroll-driven animations run it natively off the compositor;
  // the rest mirror the same 0..150px mapping from scroll events, rAF-
  // throttled. Reduced motion keeps the old threshold flip via is-scrolled.
  if (
    !CSS.supports('animation-timeline: scroll()') &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    const RANGE = 150;
    let queued = null;
    const setProgress = () => {
      queued = null;
      document.body.style.setProperty(
        '--header-progress',
        String(Math.min(1, Math.max(0, window.scrollY / RANGE)))
      );
    };
    window.addEventListener(
      'scroll',
      () => {
        queued ??= requestAnimationFrame(setProgress);
      },
      { passive: true }
    );
    setProgress();
  }

  let scrolled = false;
  const update = () => {
    const s = window.scrollY > 55;
    if (s !== scrolled) {
      scrolled = s;
      root.classList.toggle('is-scrolled', s);
      // The flip changes --header-height-current (mobile header shrinks), which
      // moves the sticky projects filter and its panel height cap. An open
      // panel's max-height is a frozen pixel value that toggle.js only
      // re-measures on resize — so nudge it.
      window.dispatchEvent(new Event('resize'));
    }
  };
  update();
  window.addEventListener('scroll', update, { passive: true });
}

export function startupTheme() {
  setScrollBarWidth();
  setupHeaderScroll();

  const onResize = debounce(() => {
    setScrollBarWidth();
    onLoadOrResize();
  });
  window.addEventListener('resize', onResize);

  document.addEventListener("DOMContentLoaded", () => {
    menuToggler()
    mobileViewHeightFix()

    window.addEventListener('load', onLoadOrResize)
  });
}

console.log(`%c
       ___                         ___           ___           ___
      /  /\\                       /__/\\         /__/\\         /  /\\
     /  /:/_                      \\  \\:\\        \\  \\:\\       /  /::|
    /  /:/ /\\    ___     ___       \\  \\:\\        \\  \\:\\     /  /:/\:|
   /  /:/_/::\\  /__/\\   /  /\\  ___  \\  \\:\\   _____\\__\\:\\   /  /:/|:|__
  /__/:/__\\/\\:\\ \\  \\:\\ /  /:/ /__/\\  \\__\\:\\ /__/::::::::\\ /__/:/ |:| /\\
  \\  \\:\\ /~~/:/  \\  \\:\\  /:/  \\  \\:\\ /  /:/ \\  \\:\\~~\\~~\\/ \\__\\/  |:|/:/
   \\  \\:\\  /:/    \\  \\:\\/:/    \\  \\:\\  /:/   \\  \\:\\  ~~~      |  |:/:/
    \\  \\:\\/:/      \\  \\::/      \\  \\:\\/:/     \\  \\:\\          |  |::/
     \\  \\::/        \\__\\/        \\  \\::/       \\  \\:\\         |  |:/
      \\__\\/                       \\__\\/         \\__\\/         |__|/

 www.glunz.ch
 `, `font-family: monospace`);
